var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lib__text-center"},[(_vm.waiting)?_c('Loader',{attrs:{"label":_vm.waitingLabelWithCounter}}):(_vm.loading)?_c('Loader',{attrs:{"label":_vm.$t('appointment.loadingAvailabilities')}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }